import React from "react";

export default function RhombusVertical() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="100"
      height="100"
      viewBox="0 0 66 65"
    >
      <path fill="#fff" d="M0 .34h65.016v64H0z" />
      <path
        fill="#000"
        d="M2.96 11.382.275 14.066l2.632 2.632 2.685-2.684-2.632-2.632ZM3.166 27.12.48 29.805l2.632 2.632 2.685-2.685-2.632-2.632ZM3.166 37.635.48 40.32l2.632 2.632 2.685-2.685-2.632-2.632ZM.584 61.45V50.688l2.612-2.676 2.68 2.715v10.721L3.23 64.095.584 61.45ZM8.527 42.859l-2.685 2.684 2.632 2.632 2.685-2.684-2.632-2.632ZM8.595 53.58l-2.684 2.685v5.013h5.316v-5.066L8.595 53.58Z"
      />
      <path
        fill="#000"
        d="m8.595 64.142-2.684-2.685v-5.012h5.316v5.065l-2.632 2.632ZM13.887 11.313l-2.684 2.685 2.632 2.632 2.684-2.685-2.632-2.632ZM13.887 32.343l-2.684 2.685 2.632 2.632 2.684-2.685-2.632-2.632ZM13.956 53.649l-2.685 2.684v5.013h5.317v-5.065l-2.632-2.632Z"
      />
      <path
        fill="#000"
        d="m13.956 64.21-2.685-2.684v-5.013h5.317v5.066l-2.632 2.632ZM19.248 11.313l-2.685 2.685 2.632 2.632 2.685-2.685-2.632-2.632ZM19.248 48.15l-2.685 2.685 2.632 2.632 2.685-2.684-2.632-2.632Z"
      />
      <path
        fill="#000"
        d="m19.248 58.666-2.685 2.685 2.632 2.632 2.685-2.685-2.632-2.632ZM22.027 19.595V8.834l2.612-2.676 2.68 2.715v10.722l-2.646 2.646-2.646-2.646ZM24.677 53.649l-2.684 2.684v5.013h5.317v-5.065l-2.633-2.632Z"
      />
      <path
        fill="#000"
        d="m24.677 64.21-2.684-2.684v-5.013h5.317v5.066l-2.633 2.632ZM29.97.866l-2.685 2.685 2.632 2.632L32.6 3.498 29.97.866ZM19.317 32.343l-2.685 2.685v5.013h5.317v-5.066l-2.632-2.632Z"
      />
      <path
        fill="#000"
        d="m19.317 42.905-2.685-2.684v-5.013h5.317v5.065l-2.632 2.632ZM24.677 32.343l-2.684 2.685v5.013h5.317v-5.066l-2.633-2.632Z"
      />
      <path
        fill="#000"
        d="m24.677 42.905-2.684-2.684v-5.013h5.317v5.065l-2.633 2.632ZM29.97 11.313l-2.685 2.685 2.632 2.632 2.684-2.685-2.632-2.632ZM29.97 21.828l-2.685 2.685 2.632 2.632L32.6 24.46l-2.632-2.632ZM29.97 42.859l-2.685 2.684 2.632 2.632 2.684-2.684-2.632-2.632ZM35.33.866l-2.685 2.685 2.633 2.632 2.684-2.685L35.33.866ZM35.33 16.605l-2.685 2.685 2.633 2.632 2.684-2.685-2.632-2.632ZM35.33 32.343l-2.685 2.685 2.633 2.632 2.684-2.685-2.632-2.632ZM35.33 58.666l-2.685 2.685 2.633 2.632 2.684-2.685-2.632-2.632ZM38.11 19.388V8.628l2.61-2.676 2.681 2.715v10.721l-2.646 2.646-2.646-2.646ZM38.11 45.642v-10.76l2.61-2.676 2.681 2.715v10.721l-2.646 2.646-2.646-2.646ZM43.47 14.303V3.542L46.08.866l2.68 2.715v10.722l-2.645 2.645-2.646-2.646Z"
      />
      <path
        fill="#000"
        d="M43.47 19.388V8.628l2.611-2.676 2.68 2.715v10.721l-2.645 2.646-2.646-2.646ZM5.773 24.68V13.92l2.612-2.676 2.68 2.715V24.68L8.42 27.326 5.773 24.68ZM43.47 40.419v-10.76l2.611-2.676 2.68 2.714V40.42l-2.645 2.646-2.646-2.646Z"
      />
      <path
        fill="#000"
        d="m51.412 6.09-2.684 2.684 2.632 2.632 2.684-2.684-2.632-2.632ZM48.83 35.127v-10.76l2.612-2.676 2.68 2.714v10.722l-2.645 2.646-2.646-2.646ZM51.481 48.082l-2.685 2.685v5.012h5.317v-5.065l-2.632-2.632Z"
      />
      <path
        fill="#000"
        d="m51.481 58.644-2.685-2.685v-5.013h5.317v5.066l-2.632 2.632ZM56.773 16.605l-2.685 2.685 2.632 2.632 2.685-2.685-2.632-2.632ZM56.773 27.12l-2.685 2.685 2.632 2.632 2.685-2.685-2.632-2.632ZM54.191 50.865v-10.76l2.612-2.676 2.68 2.715v10.721l-2.646 2.646-2.646-2.646ZM8.488.866h10.76l2.676 2.612-2.715 2.68H8.488L5.842 3.512 8.488.866ZM13.986 27.12h10.76l2.676 2.612-2.715 2.68H13.986l-2.646-2.646 2.646-2.646ZM62.065.798 59.38 3.482l2.632 2.632 2.685-2.684L62.065.798ZM62.065 21.965 59.38 24.65l2.632 2.632 2.685-2.684-2.632-2.633ZM62.065 32.343l-2.685 2.685 2.632 2.632 2.685-2.685-2.632-2.632Z"
      />
      <path
        fill="#000"
        d="m62.065 42.927-2.685 2.685 2.632 2.632 2.685-2.685-2.632-2.632ZM62.065 53.236l-2.685 2.685 2.632 2.632 2.685-2.684-2.632-2.633Z"
      />
    </svg>
  );
}
